import * as types from "./types";



export const setWindowSize = (width) => ({
    type: types.SET_WINDOW_SIZE, 
    payload: width
});

export const setPageSearch = ({search}) => ({
  type: types.SET_PAGE_SEARCH, 
  payload: search
});

